export default "__VITE_ASSET__9RhfNbhF__"